<template>
  <div class="c-categoryBox" :class="boxModifier">
    <div class="c-categoryBox_grid c-categoryBox_grid--info">
      <div class="c-categoryBox_row c-categoryBox_row--alignStart">
        <div class="c-categoryBox_wrap c-categoryBox_wrap--title">
          <avatar-company
            class="c-categoryBox_logo"
            :logo="company.logo"
            :name="company.name"
            :alt="`logo da empresa ${company.name}`"
            :title="company.name"
          />
          <div class="c-categoryBox_nameWrap">
            <h2 class="c-categoryBox_name">
              <slot name="name"> </slot>
              <p class="c-categoryBox_badge c-categoryBox_badge--verified tooltip-multiline tooltip-bottom tooltip-text-center" :data-tooltip="'Verificado'" v-if="checked">
              </p>
            </h2>
            <span v-if="isAdmPartner"
              class="c-categoryBox_360 tooltip-dark tooltip-multiline tooltip-bottom-left tooltip-lg tooltip-text-center"
              :data-tooltip="'Esta empresa é parceira do SíndicoNet e também utiliza o CoteiBem para fazer cotações para os seus clientes, garantindo mais transparência e segurança aos condomínios administrados.'">
                <img class="c-categoryBox_stampIcon" :src="require('icon/custom/selo-360-small.svg')" alt="" />
            </span>
          </div>


        </div>
      </div>

      <div class="c-categoryBox_row">
        <div class="c-categoryBox_wrap c-categoryBox_wrap--info">
          <slot name="description"></slot>
        </div>
      </div>

      <div class="c-categoryBox_row c-categoryBox_row--alignEnd">
        <div class="c-categoryBox_wrap c-categoryBox_wrap--link" @click="trackClick()">
          <a class="c-categoryBox_link c-categoryBox_link--small" :href="profileUrl" title="ver perfil da empresa">
            Ver mais no perfil da empresa
          </a>
        </div>
      </div>
    </div>

    <div class="c-categoryBox_grid c-categoryBox_grid--rating">
      <div class="c-categoryBox_row c-categoryBox_row--alignCenter" v-show="hasRating">
        <div class="c-categoryBox_wrap c-categoryBox_wrap--score">
          <p class="c-categoryBox_score">{{ companyRating }}</p>
        </div>
        <div class="c-categoryBox_wrap c-categoryBox_wrap--rating">
          <i class="c-categoryBox_star" :class="ratingStyle"></i>
          <p class="c-categoryBox_legend">({{ company.totalEvaluation }}) opiniões</p>
        </div>
      </div>

      <div class="c-categoryBox_row" v-show="!hasRating">
        <div class="c-categoryBox_wrap c-categoryBox_wrap--empty">
          <div class="m-emptyState m-emptyState--row m-emptyState--micro">
            <img class="m-emptyState_image" :src="require('icon/custom/category-star-hourglass.svg')" alt="poste indicador" title="endereco não encontrado">
            <p class="m-emptyState_title">Este fornecedor ainda não tem avaliações de usuários</p>
          </div>
        </div>
      </div>
      <div class="c-categoryBox_row">
        <categoryParticipationIndex :progress="company.participationIndex" />
      </div>
      <div class="c-categoryBox_row c-categoryBox_row--alignEnd">
        <div class="c-categoryBox_wrap c-categoryBox_wrap--button">
          <button class="c-categoryBox_button" :class="buttonStyle" @click="toggleCompany()">
            Adicionar
          </button>
          <div class="c-categoryBox_wrap c-categoryBox_wrap--heart">
            <button
              class="c-categoryBox_heart c-categoryBox_heart--loved"
              v-show="isFavorite"
              @click="removeFavorite(company)">
            </button>

            <button
              class="c-categoryBox_heart"
              v-show="!isFavorite"
              @click="addFavorite(company)">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState, mapActions } from 'vuex'
import { parse as parseUrl } from 'url'
import { parse as parseQuery, stringify } from 'qs'
import { companyProfile } from 'routes'
import { StoreState } from 'Types'
import { addFavorite, removeFavorite } from 'Api/favoriteApi'
import { notifyError } from 'Services/vueNotifier'
import { openModal } from 'Services/vueModal'
import { starRating } from 'Services/ratingFormat'
const avatarCompany = () => import('Components/avatarCompany.vue')
const imgAvatar = () => import('Components/imgAvatar.vue')
const modalLogin = () => import('Components/Modal/modalLogin.vue')
const categoryParticipationIndex = () => import('Components/CategoryDirectory/categoryParticipationIndex.vue')

export default {
  props: {
    category: {
      required: true
    },
    city: {
      required: true
    },
    id: {
      required: true
    },
    logo: {
      required: true
    },
    name: {
      required: true
    },
    rating: {
      required: true
    },
    serviceType: {
      required: true
    },
    servicesDescription: {
      required: true
    },
    slug: {
      required: true
    },
    totalEvaluation: {
      required: true
    },
    checked: {
      required: false
    },
    isAdmPartner: {
      required: true
    },
    participation: {
      required: false
    }
  },


  components: {
    imgAvatar,
    modalLogin,
    avatarCompany,
    categoryParticipationIndex
  },

  mounted() {
  },

  computed: {
    ...mapState({
      requestingHearts: (state: StoreState) => state.categoryDirectory.requesting.hearts,
      companyList: (state: StoreState) => state.categoryDirectory.companyList,
      favoriteCompaniesList: (state: StoreState) => state.categoryDirectory.favoriteCompaniesList,
      isAuthenticated: (state: StoreState) => state.account.authenticated,
      selectedCompanies: (state: StoreState) => state.categoryDirectory.selected.companies,
      viewMode: (state: StoreState) => state.categoryDirectory.selected.mode,
      selectedCompanyLimit: (state: StoreState) => state.categoryDirectory.selectedCompanyLimit,
    }),

    company() {
      return {
          category: this.category,
          city: this.city,
          id: this.id,
          checked: this.checked,
          isFavorite: false,
          logo: this.logo,
          name: this.name,
          rating: this.rating,
          serviceType: this.serviceType,
          servicesDescription: this.servicesDescription,
          slug: this.slug,
          totalEvaluation: this.totalEvaluation,
          participationIndex: this.participation
      }
    },

    isFavorite() {
      return this.favoriteCompaniesList.some(company => {
        return company.id === this.id
      })
    },

    maxSelectedCompanies() {
      return this.selectedCompanies.length >= this.selectedCompanyLimit
    },

    boxModifier() {
      const propModifier = this.viewMode.type === 'list' || this.viewMode.type === 'map'
        ? `c-categoryBox--responsive`
        : `c-categoryBox--grid`

      const disabledModifier = !this.isSelected && this.maxSelectedCompanies
        ? 'c-categoryBox--disabled'
        : ''

      return [propModifier, disabledModifier].join(' ')
    },

    buttonStyle() {
      return this.isSelected
        ? 'c-categoryBox_button--selected'
        : ''
    },

    hasRating() {
      return this.parsedRating !== null
        && this.parsedRating > 0
    },

    parsedRating() {
      if(this.company.rating !== null) {
        return parseFloat(this.company.rating.toString().replace(',', '.'))
      }
      return 0
    },

    ratingStyle() {
      const value = starRating(this.parsedRating || 0)

      return `c-categoryBox_star--${value}`
    },

    companyRating() {
      const rating = this.parsedRating
        ? this.parsedRating
        : 0
      return rating
    },

    shortDescription() {
      const { servicesDescription } = this.company
      const trucanteSize = 75

      return servicesDescription && servicesDescription.length > trucanteSize
        ? servicesDescription.substring(0, trucanteSize) + '...'
        : servicesDescription
    },

    isSelected() {
      return this.selectedCompanies.some(item => item.id === this.company.id)
    },

    profileUrl() {
      return companyProfile.index(this.company.slug)
    }
  },

  methods: {
    ...mapActions({
      updateCategoryCompanyList: 'categoryDirectory/updateCategoryCompanyList',
      updateCategorySelected: 'categoryDirectory/updateCategorySelected',
      getFavoriteHearts: 'categoryDirectory/getFavoriteHearts',
    }),

    authUser() {
      const props = { avoidRedirect: true, done: () => location.reload() }
      const params = { clickToClose: true }

      openModal(this, modalLogin, { props,  params })
    },

    async addFavorite(company) {
      var dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'favoriteProvider',
        'provider': this.company.name
      })
      if (!this.isAuthenticated) {
        return this.authUser()
      }


      try {
        const result = await addFavorite(company.id)

        return this.getFavoriteHearts()
      } catch (err) {
        notifyError(this, err)

        throw err
      }
    },

    async removeFavorite(company) {

      var dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'removeFavoriteProvider',
        'provider': this.company.name
      })

      try {
        const result = await removeFavorite(company.id)

        return this.getFavoriteHearts()
      } catch (err) {
        notifyError(this, err)

        throw err
      }
    },

    updateCompanyQuery(companies) {
      const { href, search, query } = parseUrl(location.href)

      const currentQuery = parseQuery(query)

      const companyQuery = {
        companies: companies.map(company => {
          return company.id + '*' + company.name.substring(0, 19)
        }).join(',')

      }

      const queries = {
        ...currentQuery,
        ...companyQuery,
      }

      const url = href.replace(search, '') + '?' + stringify(queries)
      history.replaceState(history.state, '', url)
    },

    toggleCompany() {
      if (this.isSelected) {
        this.removeCompany()
      } else {
        this.addCompany()
      }
    },

    addCompany() {
      if (this.maxSelectedCompanies) { return }

      this.trackAddCompany()

      const { id, name } = this.company

      const companies = [ ...this.selectedCompanies, { id, name } ]

      this.updateCategorySelected({ companies })
      this.updateCompanyQuery(companies)


    },

    trackAddCompany() {
      var dataLayer = window.dataLayer || [];
      dataLayer.push({
          'event': 'addQuotation',
          'provider': this.company.name,
          'specialty': this.serviceType,
      })
    },

    removeCompany() {
      var dataLayer = window.dataLayer || [];
      dataLayer.push({
          'event': 'removeQuotation',
          'provider': this.company.name,
          'specialty': this.serviceType,
      })

      const companies = this.selectedCompanies.filter(item => item.id !== this.company.id)
      this.updateCategorySelected({ companies })
      this.updateCompanyQuery(companies)


    },
  }
}
</script>

<style lang="scss">
@import "~css/_references";
@import "~css/Modules/box";
@import "~css/Modules/button";
@import "~css/Modules/checkbox";
@import "~css/Functions/ellipsis";

.c-categoryBox {
  @extend .m-box;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  padding: 0;
  transition: opacity $v-duration-complex $v-easing-swift-in;
  opacity: 1;
  margin-bottom: 10px;
  &--disabled {
    filter: grayscale(100%);
    opacity: 0.4;

    .c-categoryBox_button {
      cursor: default;
    }
  }

  &--grid {
    .c-categoryBox_wrap--rating {
      width: calc(100% - 80px);
    }

    .c-categoryBox_wrap--score {
      width: 48px;
    }

    .c-categoryBox_wrap--score {
      display: flex;
    }

    .c-categoryBox_score {
      font-size: 22px;
      margin-bottom: $v-gap-xxs;
    }

    .c-categoryBox_legend {
    }

    .c-categoryBox_wrap {
      &--iconAmount { display: none }
      &--title {
        width: 100%;
      }
      &--heart {
        display: flex;
        align-self: center;
      }

      &--button {
        gap: 18px;
      }
    }
    .c-categoryBox_heart {
      background-size: 100%;
    }

    .c-categoryBox_logo {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: 1px solid #E6E6EB;
      margin-left: unset;

    }

    .c-categoryBox_description {
      height: 48px;
    }

    .c-categoryBox_360 {
        margin-left: 6px;
      }
  }

  &--responsive {
    @media (min-width: $v-screen-sm) {
      flex-flow: row nowrap;

      .c-categoryBox_logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: $v-gap-xxs / 2;
        width: 80px;
      }

      .c-categoryBox_nameWrap {
        display: flex;
        flex-flow: column nowrap;
        border-top: unset;
        padding-top: unset;

      }

      .c-categoryBox_logo {
        margin-left: unset;
      }

      .c-categoryBox_360 {
        margin-left: 6px;
      }

      .c-categoryBox_grid {
        border-bottom: 0;
        border-right: 1px solid $v-colorGray-light-3;
        padding: $v-gap-sm;

        &:last-of-type {
          border-right: 0
        }

        &--brand {
          width: 142px;
          max-width: 142px;
          height: auto;
          max-height: 100%;
          flex-shrink: 0;
        }

        &--rating {
          width: 370px;
          max-width: 370px;
          height: auto;
          max-height: 100%;
          flex-shrink: 0;
        }
      }

      .c-categoryBox_wrap {
        &--title {
          display: flex;
          align-items: center;
          flex-direction: row;
          width: calc(100% - #{$v-gap-mdl})
        }
        &--heart {
          width: $v-gap-mdl
        }

        &--rating {
          width: calc(100% - 100px)
        }

        &--score {
          width: 48px;
        }

        &--iconAmount {
          display: none;
        }
      }

      .c-categoryBox_heart {
        &::after {
          content: 'favoritar';
        }

        &--loved::after {
          content: 'favoritado';
          top: 30px;
          left: -13px;
        }
      }
    }

    @media (min-width: $v-screen-lg) {
      flex-flow: row nowrap;

      .c-categoryBox_wrap {

        &--score {
          display: block;
        }

        &--iconAmount {
          display: block;
        }

        &--rating {
          width: calc(100% - 100px)
        }

        &--score {
          width: 48px;
        }
      }

      .c-categoryBox_grid {
        &--rating {
          min-width: 308px;
        }
      }

      .c-categoryBox_button::after {
         content: ' na cotação';
         white-space: pre;
      }
    }
  }

  &_grid {
    display: flex;
    flex-flow: column nowrap;
    padding: $v-gap-xs;
    border-bottom: 1px solid $v-colorGray-light-3;
    flex-grow: 1;

    &--brand {
      box-sizing: border-box;
      height: 142px;
      max-height: 142px
    }

    &--rating {
      box-sizing: border-box;
    }

    &:last-of-type { border-bottom: 0 }
  }

  &_row {
    display: flex;
    flex-flow: row wrap;
    align-items: center;

    &--alignCenter {
      gap: 18px;
      align-items: center;
    }

    &--alignStart {
      align-items: flex-start;
    }

    &--alignEnd {
      flex-grow: unset;
      margin-top: auto;
      align-items: flex-end;
    }

    &--justifyAround {
      justify-content: space-around;
    }
  }

  &_wrap {
    &--title {
      width: calc(100%);
    }

    &--heart {
      align-self: flex-start;
      width: $v-gap-md;
      @include f-media("<tablet") {
        align-self: center;
      }
    }

    &--label {
      display:flex;
      flex-flow: row wrap;
      width: 100%;
      align-items: flex-start;
      padding: $v-gap-xxs / 2;
    }

    &--info {
      width: 100%;
      padding: $v-gap-xxs 0;
    }

    &--link {
      width: 100%;
      padding: $v-gap-xxs
    }

    &--icon,
    &--iconAmount {
      flex-basis: calc(100% / 3);
      max-width: 90px;
      text-align: center;
    }

    &--rating {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      text-align: left;
      width: calc(100% - 100px)
    }

    &--score {

    }

    &--button {
      display: flex;
      gap: 34px;
      width: 100%;
      margin-bottom: 0;
      padding: $v-gap-xxs;
      margin-top: $v-gap-xxs;
    }
  }

  &_logo {
    margin-left: calc(50% - 50px);
  }

  &_nameWrap {
    padding-top: 20px;
    border-top: 1px solid #E6E6EB;
  }

	&_name {
		font-family: $v-fontFamily-brand;
		font-weight: 500;
		font-size: 18px;
		color: $v-colorBlue;
    padding: $v-gap-xxs;
    text-decoration: none;
    max-width: 300px;
    display: flex;
  }

  &_360 {
    margin-left: 6px;
  }

  &_stampIcon {
    margin-top: 5px;
    display: flex;
  }

  &_badge {
    // @include f-ellipsis(100%);
    box-sizing: border-box;
		color: $v-colorGray-dark-4;
		font-size: 14px;
    padding: $v-gap-xxs $v-gap-xxs $v-gap-xxs ($v-gap-sml + 3px);
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: $v-gap-xxs / 2 center;
    background-size: 16px;

		&--qualified {
			background-image: url(~icon/custom/category-qualified.svg);
		}

		&--verified {
      margin-left: 12px;
			background-image: url(~icon/custom/category-verified.svg);
		}
  }

  &_heart {
    position: relative;
    padding: 0;
    width: 32px;
		height: 32px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 80%;
    background-image: url('~icon/custom/category-heart.svg');
    cursor: pointer;
    border: 0;
    transition: all $v-duration-enter $v-easing-swift-in;

    &::after {
      position: absolute;
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: $v-colorGray;
      top: 30px;
      left: -8px;
      text-align: center;
    }

    &:active {
      background-size: 90%;
    }

    &:focus,
    &:active {
      outline: 0;
    }

    &--loved {
      background-image: url('~icon/custom/category-heart-loved.svg');
    }

    &--loading {
      @include f-animate-loadingLight();
      cursor: progress;

      &::after {
        display: none;
      }
    }

    @include f-media("<tablet") {
      background-size: 100%;
    }
  }

  &_label {
    box-sizing: border-box;
    display: block;
    padding: 4px 7px;
    margin: $v-gap-xxs / 2;
    font-size: 13px;
    color: $v-colorBlack;
    background-color: $v-colorGray-light-3;
    border-radius: 3px;

    &--success {
      background: $v-colorGreen;
      color: $v-colorWhite;
    }
  }

  &_labelEmphasis {
    color: $v-colorRed;
    font-weight: 600;
  }

  &_description {
    padding: $v-gap-xxs;
    position: relative;
    flex-basis: 100%;
    font-size: 15px;
    line-height: 1.4;
    height: auto;
    max-height: 72px;
    overflow: hidden;
    box-sizing: border-box;
    word-break: break-word;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      right: 0;
      width: 80px;
      height: 100%;
      background: linear-gradient(to right, rgba($v-colorWhite , 0) 0%, rgba($v-colorWhite, 1) 100%);
    }

    &--primary {
      color: $v-colorDark-primary;
    }

    &--secondary {
      color: $v-colorGray-light;
    }
  }

  &_link {
    @include f-ellipsis(auto);
    display: block;
    text-decoration: none;
    color: $v-colorGreen-dark;

    &--small {
      font-size: 14px;
      color: $v-colorYellow-dark-3
    }

    &--rating {
      padding: $v-gap-xxs;
      font-size: 14px;
    }

  }

  &_star {
    display: block;
    width: 100%;
		max-width: 160px;
		height: 24px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: left center;
    margin: $v-gap-xxs 0 $v-gap-xxs 0;

    &--0  { background-image: url('~icon/custom/rating-star-0.svg') }
    &--0h  { background-image: url('~icon/custom/rating-star-0h.svg') }
    &--1  { background-image: url('~icon/custom/rating-star-1.svg')  }
    &--1h { background-image: url('~icon/custom/rating-star-1h.svg') }
    &--2  { background-image: url('~icon/custom/rating-star-2.svg')  }
    &--2h { background-image: url('~icon/custom/rating-star-2h.svg') }
    &--3  { background-image: url('~icon/custom/rating-star-3.svg')  }
    &--3h { background-image: url('~icon/custom/rating-star-3h.svg') }
    &--4  { background-image: url('~icon/custom/rating-star-4.svg')  }
    &--4h { background-image: url('~icon/custom/rating-star-4h.svg') }
		&--5  { background-image: url('~icon/custom/rating-star-5.svg')  }
  }

  &_score {
    display: block;
    margin: 0 auto;
    text-align: center;
    font-size: 26px;
    color: $v-colorDark-primary;
  }

  &_legend {
    display: block;
    text-align: left;
    font-size: 14px;
    color: $v-colorGray-light;
    padding: $v-gap-xxs 0 $v-gap-xxs 0;

    &--tiny {
      font-size: 12px;
    }
  }

  &_number {
    height: 30px;
    font-size: 22px;
    line-height: 1.35;
    color: $v-colorGray;
    margin-top: $v-gap-xs;
  }

  &_icon {
    display: block;
    width: 30px;
    height: 30px;
    margin: $v-gap-xs auto 0 auto;
  }

  &_button {
    cursor: pointer;
    width: 100%;
    height: 45px;
    color: $v-colorGray-dark-3;
    background-color: $v-colorYellow-2;
    border: 1px solid $v-colorYellow;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    transition: all $v-duration-enter $v-easing-swift-in;
    line-height: 1.7;

    &:disabled {
      filter: grayscale(100%);
    }

    &:focus {
      outline: 0;
    }

    &::before {
      content: '';
      flex-shrink: 0;
      height: 24px;
      width: 24px;
      border-radius: $v-boxRadius;
      border: 2px solid $v-colorGray-light-1;
      background: $v-colorWhite;
      margin-right: $v-gap-xs;
      transition: background-image $v-duration-enter $v-easing-swift-in;
    }

    &--selected {
      background: $v-colorGreen-light;
      border-color: $v-colorGreen-dark;

      &::before {
        background: url("~icon/custom/checkbox-mark.svg") center / 70% no-repeat, $v-colorWhite;
      }
    }
  }

  p[data-tooltip] {
    &:before {
      max-width: 100px !important;
    }
  }
}
</style>